import React, { Fragment } from "react";
import DataTable from "react-data-table-component";
import "react-toastify/dist/ReactToastify.css";
import DataTableExtensions from "react-data-table-component-extensions";
import placeholder from "../../assets/images/fashion/product/12.jpg";
const UserExchangeItems = ({  myData, myClass }) => {
  const columnDefs = [
    {
      name: "Old Product Image",
      cell: (row) => (
        <ItemsImage
          image={row.oldItemId ? row?.oldItemId?.bannerImage : placeholder}
        />
      ),
    },
    {
      name: "Old Product Name",
      selector: (row) => row?.oldItemId?.name,
      sortable: true,
    },
    {
      name: "Old Items Price",
      selector: (row) => `€ ${row?.oldItemId?.sellPrice}`,
      sortable: true,
    },
    {
      name: "New Product Image",
      cell: (row) => (
        <ItemsImage
          image={
            row.newProductId ? row?.newProductId?.bannerImage : placeholder
          }
        />
      ),
    },
    {
      name: "New Product Name",
      selector: (row) => row?.newProductId?.name,
      sortable: true,
    },
    {
      name: "New Items Price",
      selector: (row) => `€ ${row?.newProductId?.sellPrice}`,
      sortable: true,
    },
  ];
  return (
    <div>
      <Fragment>
        <DataTableExtensions
          columns={columnDefs}
          data={myData}
          print={false}
          export={false}>
          <DataTable
            data={myData}
            columns={columnDefs}
            className={myClass}
            pagination
            striped={true}
            center={true}
          />
        </DataTableExtensions>
      </Fragment>
    </div>
  );
};
const ItemsImage = ({ image }) => {
  return (
    <div className="profile-image">
      <img src={image} alt="logo" />
    </div>
  );
};
export default UserExchangeItems;
